const controller: AbortController = new AbortController()

export const signal: AbortSignal = controller.signal
